import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_OVERVIEW_REPORTS} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const Overview = lazy(() =>
  import('../../../screens/Overview')
    .then(module => ({default: module.Overview})));

const OverviewNavigation = [
  {
    path: ROUTE_OVERVIEW_REPORTS,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <Overview />
      </Suspense>
    ),
  },
];

export default OverviewNavigation;
